import React from 'react';
import { Hero } from '../components/home/Hero';
import { About } from '../components/home/About';
import { Expertise } from '../components/home/Expertise';
import { Timeline } from '../components/home/Timeline';
import { Achievements } from '../components/home/Achievements';
import { SelectedTransactions } from '../components/home/SelectedTransactions';
import { PublicCompany } from '../components/home/PublicCompany';
import { BoardExperience } from '../components/home/BoardExperience';
import { Credentials } from '../components/home/Credentials';
import { Philosophy } from '../components/home/Philosophy';
import { Testimonials } from '../components/home/Testimonials';
import { InsightsPreview } from '../components/home/InsightsPreview';
import { ContactCta } from '../components/home/ContactCta';
export function Home() {
  return <main data-id="element-367" data-mp="3kuqv182hprik">
      <Hero data-id="element-368" data-mp="3kv0oj5mqugt0" />
      <About data-id="element-369" data-mp="3kxmu4zq2qm8l" />
      <Expertise data-id="element-370" data-mp="3owvmc05guc21" />
      <Timeline data-id="element-371" data-mp="3owce5b5mb217" />
      <Achievements data-id="element-372" data-mp="3ovucfz06rvlw" />
      <SelectedTransactions data-id="element-373" data-mp="3ovavakid1b8x" />
      <PublicCompany data-id="element-374" data-mp="3oyq6vdcts25l" />
      <BoardExperience data-id="element-375" data-mp="30xb9e3tcoxwq" />
      <Credentials data-id="element-376" data-mp="30vqak2006st2" />
      <Philosophy data-id="element-377" data-mp="30w06053ths65" />
      <Testimonials data-id="element-378" data-mp="30ufbgfhi698a" />
      <InsightsPreview data-id="element-379" data-mp="2vxyc0p4us8fw" />
      <ContactCta data-id="element-380" data-mp="2vyq8012d486p" />
    </main>;
}